// extracted by mini-css-extract-plugin
module.exports = {"input-container":"input-core_input-container__XTU2P","input-icon":"input-core_input-icon__8xH0U","input":"input-core_input__db4mI"};